import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, Renderer2} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { ProjectEditingComponent } from 'src/app/back-office/components/edit-project/project-editing/project-editing.component';
import config from 'config/default.json';
import { MarkdownEditorComponent } from 'src/app/back-office/components/markdown-editor/markdown-editor.component';
@Component({
  selector: 'app-vca-detail-content',
  templateUrl: './vca-detail-content.component.html',
  styleUrls: ['./vca-detail-content.component.scss']
})
export class VcaDetailContentComponent {
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiServiceModule,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private helper: HelperModule,
    public dialog: MatDialog
    ) {}
  config = config;
  @Input() rowInfos: { [x:string]: any } = new Map();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() projectInfos: { [x:string]: any } = new Map();
  platformInfos:{[x: string]: any} = {origin: 'virtualcampus', key: 'vca', root: 'VIRTUALCAMPUS'};
  
  pdfMode:string = 'edit';

  @Output() inProgress = new EventEmitter<any>();
  @Output() updateStates = new EventEmitter<any>();
  @Output() updateContent = new EventEmitter<any>();

  countryControl = new FormControl();
  institutionControl = new FormControl();
  structureControl = new FormControl();
  moduleControl = new FormControl();
  yearControl = new FormControl();
  sectionControl = new FormControl();
  typeControl = new FormControl();
  chapterControl = new FormControl();
  learningControl = new FormControl();
  subjectControl = new FormControl();
  nameControl = new FormControl();
  linkControl = new FormControl();
  containsAnswerControl = new FormControl();
  rawValidControl = new FormControl();

  searchCountryControl = new FormControl();
  searchInstitutionControl = new FormControl();
  searchStructureControl = new FormControl();
  searchModuleControl = new FormControl();
  searchYearControl = new FormControl();
  searchSectionControl = new FormControl();
  searchChapterControl = new FormControl();
  searchLearningControl = new FormControl();
  searchTypeControl = new FormControl();
  searchSubjectControl = new FormControl();

  filteredCountries: { [x:string]: string|number|boolean }[] = [];
  filteredInstitutions: { [x:string]: string|number|boolean }[] = [];
  filteredStructures: { [x:string]: string|number|boolean }[] = [];
  filteredModules: { [x:string]: string|number|boolean }[] = [];
  filteredYears: { [x:string]: string|number|boolean }[] = [];
  filteredSections: { [x:string]: string|number|boolean }[] = [];
  filteredChapters: { [x:string]: string|number|boolean }[] = [];
  filteredLearnings: { [x:string]: string|number|boolean }[] = [];
  filteredTypes: { [x:string]: string|number|boolean }[] = [];
  filteredSubjects: { [x:string]: string|number|boolean }[] = [];

  countries: { [x:string]: string|number|boolean }[] = [];
  institutions: { [x:string]: string|number|boolean }[] = [];
  structures: { [x:string]: string|number|boolean }[] = [];
  modules: { [x:string]: string|number|boolean }[] = [];
  years: { [x:string]: string|number|boolean }[] = [];
  sections: { [x:string]: string|number|boolean }[] = [];
  types: { [x:string]: string|number|boolean }[] = [];
  subjects: { [x:string]: string|number|boolean }[] = [];
  chapters: { [x:string]: string|number|boolean }[] = [];
  learnings: { [x:string]: string|number|boolean }[] = [];

  showContentChapter:boolean = false;
  showContentLearning:boolean = false;
  showContentSubject:boolean = false;

  pdfRawData!:{ [x:string]: any };
  pdfEditData!:{ [x:string]: any };

  zoomOut:boolean = false;
  zoomIn:boolean = false;


  topicName: string = '';

  rowId: number = 0;
  source: string = 'content';
  hasEdit: boolean = true;
  isRawClassify = false;

  ngOnInit(){
    this.isRawClassify = this.rowInfos['source'] == 'project' && this.projectInfos['state'] == 'splitting';
    this.pdfMode = this.isRawClassify ? 'raw': this.pdfMode;
    this.source = this.rowInfos['source'];
    this.rowId = this.rowInfos['id_content'];
    this.cdRef.detectChanges();
    this.loadOneInfos();
    if(['project', 'other_project'].includes(this.source)){
      this.hasEdit = this.rowInfos['edit_file_pdf']? true : false;
      this.pdfMode = !this.hasEdit? 'raw': this.pdfMode;
      
      this.pdfRawData = {contents: [{id_content: this.rowInfos['id_content'], url: this.config.master.ndapi.url + '/VIRTUALCAMPUS/'+this.rowInfos['raw_file_path']}], source: 'master', height: 320};
      this.pdfEditData = {contents: [{id_content: this.rowInfos['id_content'], url: this.config.master.ndapi.url + '/VIRTUALCAMPUS/'+this.rowInfos['edit_file_pdf']}], source: 'master', height: 320};
    }else{
      this.pdfRawData =  {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCAMPUS/'+this.rowInfos['raw_file_path']}], source: 'service', height: 320};
      this.pdfEditData = {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCAMPUS/'+this.rowInfos['edit_file_pdf']}], source: 'service', height: 320};
    }

    this.applySearch();
    
      
  }
  applySearch(){
    this.searchCountryControl.valueChanges.subscribe((text) => {
      return this.filteredCountries = this.countries.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchInstitutionControl.valueChanges.subscribe((text) => {
      return this.filteredInstitutions = this.institutions.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchStructureControl.valueChanges.subscribe((text) => {
      return this.filteredStructures = this.structures.filter(element => this.normalizeString(`${element['name']} ${element['full_name']}`).includes(this.normalizeString(text)));
    });
    this.searchModuleControl.valueChanges.subscribe((text) => {
      return this.filteredModules = this.modules.filter(element => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchYearControl.valueChanges.subscribe((text) => {
      return this.filteredYears = this.years.filter(element => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchSectionControl.valueChanges.subscribe((text) => {
      return this.filteredSections = this.sections.filter(element => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchChapterControl.valueChanges.subscribe((text) => {
      return this.filteredChapters = this.chapters.filter(element => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchLearningControl.valueChanges.subscribe((text) => {
      return this.filteredLearnings = this.learnings.filter((element:any) => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchTypeControl.valueChanges.subscribe((text) => {
      return this.filteredTypes = this.types.filter(element => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
    this.searchSubjectControl.valueChanges.subscribe((text) => {
      return this.filteredSubjects = this.subjects.filter((element:any) => this.normalizeString(element['full_name']).includes(this.normalizeString(text)));
    });
  }
  selectedElement(selectedOptions: FormControl, element: { [x:string]: string|number|boolean }): boolean {
    return Array.isArray(selectedOptions.value) && selectedOptions.value.includes(element['id']);
  }
  normalizeString(str:any){
    return str.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }
  
  switchEditRaw(){
    if(this.source == 'content'){
      this.pdfRawData['refresh'] = true;
      this.pdfEditData['refresh'] = true;
      this.pdfRawData =  {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCAMPUS/'+this.rowInfos['raw_file_path']}], source: 'service', height: 320};
      this.pdfEditData = {contents: [{id_content: this.rowInfos['id_content'], url: 'VIRTUALCAMPUS/'+this.rowInfos['edit_file_pdf']}], source: 'service', height: 320};
    }
    this.pdfMode = this.pdfMode == 'raw'? 'edit': 'raw';
  }
  applyUpdate(){
    let stateChecked = true;
    let moduleId = this.moduleControl.value;
    let yearId = this.yearControl.value;
    let sectionId = this.sectionControl.value;
    let chapterId = this.chapterControl.value;
    let learningId = this.learningControl.value;
    let typeId = this.typeControl.value;
    let subjectId = this.subjectControl.value;
    let nameContent = this.nameControl.value;
    let link = this.linkControl.value;

    nameContent = nameContent == '' || nameContent == null? null : nameContent;
    link = link == '' || link == null? null : link;

    if(sectionId == 4){//Course
      yearId = null;
      typeId = null;
      subjectId = null;
      learningId = null;
      if(nameContent == null || chapterId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Name / Chapter is not specified for this Course...');
      }
    }
    if([1, 2, 3, 8, 10].includes(sectionId)){//Annals
      chapterId = null;
      learningId = null;
      if(typeId == null || yearId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Year / Type is not specified...');
      }
    }
    if([5, 7].includes(sectionId)){//Exercise / Video
      yearId = null;
      chapterId = null;
      if(nameContent == null || typeId == null || learningId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Type / Name / Learning is not specified...');
      }
    }
    if(typeId != null && typeId == 2){//Type Corrected
      nameContent = null;
      if(subjectId == null){
        stateChecked = false;
        this.helper.showToast('Warning: Linked Subject is not specified for this Answer...');
      }
    }
 
    if(moduleId != null){
      let content = {
        id_content: this.rowId,
        id_module:  moduleId,
        id_year:    yearId,
        id_section: sectionId,
        id_chapter: chapterId,
        id_type:    typeId,
        id_content_subject: typeId == 2? subjectId: null,
        id_content_learning: learningId,
        content_name: nameContent,
        content_url:  link,
        contain_answer: this.containsAnswerControl.value,
        raw_valid: this.rawValidControl.value,
      }
      let data = {
        source: this.source,
        state: 'classified',
        state_checked: stateChecked,
        user_infos: this.userInfos,
        row_infos: this.rowInfos,
        content: content
      }
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/web/content/update_content_classification', data, this.userInfos['access_token']).subscribe((response:any)=>{
        this.updateContent.emit(response.contents);
        if(stateChecked) this.helper.showToast(response.message);
      });
    }else this.helper.showToast('Module is not defined...');

    
  }
  updateState(state:string, isChecked:boolean){
    this.inProgress.emit(true);
    let data = {
      source: this.source,
      state: state,
      state_checked: isChecked,
      row_infos: this.rowInfos,
      user_infos: this.userInfos,
      platform_infos: this.platformInfos
    }
    if(this.rowInfos['active'] && this.source == 'content'){
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '50%',
        position: {top: '30px' },
        data: {page: 'confirmation', text: 'This change will affect Students subscriptions. Continue ?'}
      });
      dialogRef.afterClosed().subscribe((toContinue:boolean) => {
        if(toContinue) this.applyUpdateState(config.master.ndapi.url + '/virtualcampus/web/content/update_content_state', data);
      });
    }else this.applyUpdateState(config.master.ndapi.url + '/virtualcampus/web/content/update_content_state', data);
  }
  applyUpdateState(url:string, formData:any){
    this.apiService.queryData(url, formData, this.userInfos['access_token']).subscribe((response:any)=>{
      if(response.status){
        this.updateStates.emit([{state: response.state, active: response.active, id_content: this.rowId}])
      }
      this.helper.showToast(response.message);
      this.inProgress.emit(false);
    })
  }
  loadOneInfos(){
    let inputData = {
      id_content: this.rowInfos['id_content'],
      id_project: this.source == 'project'? this.rowInfos['id_project']: null,
      id_structure: this.source == 'project'? this.rowInfos['id_structure']: null,
      module: {id: this.rowInfos['id_module'], id_year: this.rowInfos['id_year'], id_section: this.rowInfos['id_section'], id_type: this.rowInfos['id_type']},
      source: this.source
    }; 
    this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/one_module_content_parents', inputData, this.userInfos['access_token']).subscribe((data:any)=>{
      this.countries = data.country;
      this.institutions = data.institution;
      this.structures = data.structure;
      this.modules = data.module;
      this.years = data.year;
      this.sections = data.section;
      this.chapters = data.chapter;
      this.learnings = data.learning;
      this.types = data.type;
      this.subjects = data.subject;

      this.filteredCountries = this.countries;
      this.filteredInstitutions = this.institutions;
      this.filteredStructures = this.structures;
      this.filteredModules = this.modules;
      this.filteredYears = this.years;
      this.filteredSections = this.sections;
      this.filteredChapters = this.chapters;
      this.filteredLearnings = this.learnings;
      this.filteredTypes = this.types;
      this.filteredSubjects = this.subjects;

      this.countryControl.setValue(data.id_country);
      this.institutionControl.setValue(this.institutions.filter(element => element['selected']).map(el => el['id']));
      this.structureControl.setValue(this.structures.find((element) => element['selected'])!['id']);
      this.moduleControl.setValue(this.modules.find((element) => element['selected'])?.['id'] ?? null);

      this.yearControl.setValue(this.rowInfos['id_year']);
      this.sectionControl.setValue(this.rowInfos['id_section']);
      this.chapterControl.setValue(this.rowInfos['id_chapter']);

      if([5, 7].includes(this.rowInfos['id_section'])) this.learningControl.setValue(this.rowInfos['id_content_learning']);
      this.typeControl.setValue(this.rowInfos['id_type']);

      if(this.rowInfos['id_type'] == 2) this.subjectControl.setValue(this.rowInfos['id_content_subject']);
      this.nameControl.setValue(this.rowInfos['content_name']);
      this.linkControl.setValue(this.rowInfos['content_url']);
      this.containsAnswerControl.setValue(this.rowInfos['contain_answer']);
      this.rawValidControl.setValue(this.rowInfos['raw_valid']);

      this.showContentChapter = this.rowInfos['id_section'] == 4? true: false;
      this.showContentLearning = [5, 7].includes(this.rowInfos['id_section']) && this.rowInfos['id_type'] != 2? true: false;
      this.showContentSubject = this.rowInfos['id_type'] == 2? true: false;
      this.cdRef.detectChanges();
    })
  }
  updateInstitution(){
    this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/institution', {id_country: this.countryControl.value}, this.userInfos['access_token']).subscribe((data:any)=>{
      this.institutions = data;
      this.filteredInstitutions = this.institutions;
    });
  }
  updateStructure(){
    this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/structure', {parent_ids: this.institutionControl.value}, this.userInfos['access_token']).subscribe((data:any)=>{
      this.structures = data;
      this.filteredStructures = this.structures;
    });
  }
  updateModule(){
    this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/structure_module', {structure: this.structureControl.value}, this.userInfos['access_token']).subscribe((data:any)=>{
      this.modules = data;
      this.filteredModules = this.modules;
    });
  }
  updateSubject(){
    if(this.typeControl.value == 2){
      let data = {
        id_module: this.moduleControl.value,
        id_project: this.source == 'project'? this.rowInfos['id_project']: null,
        id_content: this.rowInfos['id_content'], 
        id_year: this.yearControl.value, 
        id_section: this.sectionControl.value, 
        source: this.source
      }
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/subject', data, this.userInfos['access_token']).subscribe((data:any)=>{
        this.subjects = data;
        this.filteredSubjects = this.subjects;
        
      });
    }
    this.resetSubjects();
    
  }
  updateLearning(){
    if([5, 7].includes(this.sectionControl.value)){
      let data = {
        id_module: this.moduleControl.value,
        id_project: this.source == 'project'? this.rowInfos['id_project']: null,
        id_content: this.rowInfos['id_content'],
        source: this.source
      }
      this.apiService.queryData(config.master.ndapi.url + '/virtualcampus/infos_child/learning', data, this.userInfos['access_token']).subscribe((data:any)=>{
        this.learnings = data;
        this.filteredLearnings = this.learnings;
      });
    }
    this.resetSubjects();
  }
  resetSubjects(){
    this.showContentChapter = this.sectionControl.value == 4? true: false;
    this.showContentLearning = [5, 7].includes(this.sectionControl.value) && this.typeControl.value != 2? true: false;
    this.showContentSubject = this.typeControl.value == 2? true: false;
    this.cdRef.detectChanges();
  }
  lunchAnswerEdition(){
    const dialogRef = this.dialog.open(MarkdownEditorComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {row_infos: this.rowInfos, user_infos: this.userInfos, platform_infos: this.platformInfos, source: this.source}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  lunchEdition(){
    const dialogRef = this.dialog.open(ProjectEditingComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {project: {id: this.rowInfos['id_project'], last_task: 'task-editing'}, content_data: [this.rowInfos], user_infos: this.userInfos, platform_infos: this.platformInfos, source: this.source}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}
